/* eslint-disable no-undef */
// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const diplomasApi = createApi({
  reducerPath: "diplomasApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_URL + "/api/diploma/",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("x-access-token", `${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addDiplomas: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "addDiplomas",
      }),
    }),
    getDiplomas: builder.mutation({
      query: (agentId) => ({
        params: { agentId },
        method: "GET",
        url: "getPendingDiplomasByAgent",
      }),
    }),
    verifyDiplomas: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "verifyDiplomas",
      }),
    }),
    updateDiplomas: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "acceptOrRejectDiploma",
      }),
    }),
    updateDiploma: builder.mutation({
      query: (data) => ({
        body: data,
        method: "PUT",
        url: "updateDiplomaById",
      }),
    }),
    getAgentsByResp: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getPendingDiplomasByResponsable",
      }),
    }),
    verifyDiploma: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "verifyDiploma",
      }),
    }),
    getAcceptedDiplomaByResponsable: builder.mutation({
      query: () => ({
        method: "GET",
        url: "getAcceptedDiplomasByResponsable",
      }),
    }),
    getAcceptedDiplomaByAgent: builder.mutation({
      query: () => ({
        method: "GET",
        url: "getAcceptedDiplomasByAgent",
      }),
    }),
    getRejectedDiplomaByAgent: builder.mutation({
      query: () => ({
        method: "GET",
        url: "getRejectedDiplomasByAgent",
      }),
    }),
    getRejectedDiplomaByResponsable: builder.mutation({
      query: () => ({
        method: "GET",
        url: "getRejectedDiplomasByResponsable",
      }),
    }),
    getDiplomasWithError: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "getDiplomasWithError",
      }),
    }),
    deleteDiploma: builder.mutation({
      query: (data) => ({
        body: data,
        method: "DELETE",
        url: "deleteDiplomaById",
      }),
    }),
    revokeDiploma: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "revokeDiploma",
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddDiplomasMutation,
  useGetDiplomasMutation,
  useUpdateDiplomasMutation,
  useUpdateDiplomaMutation,
  useVerifyDiplomaMutation,
  useGetAcceptedDiplomaByResponsableMutation,
  useGetAcceptedDiplomaByAgentMutation,
  useGetDiplomasWithErrorMutation,
  useVerifyDiplomasMutation,
  useGetAgentsByRespMutation,
  useGetRejectedDiplomaByAgentMutation,
  useDeleteDiplomaMutation,
  useGetRejectedDiplomaByResponsableMutation,
  useRevokeDiplomaMutation,
} = diplomasApi;
